import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner, Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import { useAuthStore } from '../../zustand-store/auth.store';
import { getGoogleReviewConfig, updateGoogleReviewConfig } from '../../axios/businessReviews';
import { toast } from 'react-toastify';

const GoogleReviewDetailModal = ({ isOpen, toggle, title, description, icon }) => {
  const [googleMapUrl, setGoogleMapUrl] = useState('');
  const [googlePlaceId, setGooglePlaceId] = useState('');
  const [loader, setLoader] = useState(false);
  const locationId = useAuthStore((state) => state.locationId);

  useEffect(() => {
    if (isOpen) {
      getInitialConfig();
    }
  }, [locationId, isOpen]);

  const getInitialConfig = async () => {
    const response = await getGoogleReviewConfig(locationId);
    setGoogleMapUrl(response?.data?.data?.googleMapUrl || '');
    setGooglePlaceId(response?.data?.data?.googlePlaceId || '');
  };

  const saveConfig = async () => {
    setLoader(true);
    const response = await updateGoogleReviewConfig(locationId, { googleMapUrl, googlePlaceId });
    if (response?.status === 200 || response?.status === 201) {
      toast.success('Google Reviews details saved successfully');
      toggle();
    }
    setLoader(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl">
      <ModalHeader toggle={toggle} className="bg-light px-4 py-4">
        <div className="d-flex align-items-center mt-3">
          <img
            style={{
              width: '66px',
              height: '64px',
              marginRight: '20px',
              background: 'rgb(240,240,240)',
              borderRadius: '50%'
            }}
            src={icon}
            alt="icon"
            className="p-2"
          />
          <div>
            <h5 className="mb-0">{title}</h5>
            <small className="text-muted">{description}</small>
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <ol className="mb-0">
          <li>
            <p>
              Visit{' '}
              <a
                href="https://developers.google.com/maps/documentation/places/web-service/place-id"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  borderBottom: '1px solid #000',
                  textDecoration: 'none'
                }}>
                this link
              </a>
              .
            </p>
          </li>
          <li>
            <p>Then scroll to the &lsquo;Place ID Finder&rsquo; tool.</p>
          </li>
          <li>
            <p>Add your business address and find your Place ID.</p>
          </li>
        </ol>
        <div className="mx-3">
          <input
            name="google-place-id"
            placeholder="Your Google Place ID"
            className="form-control"
            value={googlePlaceId}
            onChange={(e) => setGooglePlaceId(e.target.value)}
          />
          <p>ex: ChIJN1t_tDeuEmsRUsoyG83frY4</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={saveConfig} disabled={loader || googlePlaceId === ''}>
          {loader ? (
            <>
              <Spinner size="sm" /> {' Loading...'}
            </>
          ) : (
            'Update'
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

GoogleReviewDetailModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.any
};

export default GoogleReviewDetailModal;
